import { withPulse } from '../../core/react/pulse/PulseProvider.js';

export const withByfunnPulse = withPulse;
